import { render, staticRenderFns } from "./LeftNavDashboard.vue?vue&type=template&id=f881c2ce&scoped=true&"
import script from "./LeftNavDashboard.vue?vue&type=script&lang=js&"
export * from "./LeftNavDashboard.vue?vue&type=script&lang=js&"
import style0 from "./LeftNavDashboard.vue?vue&type=style&index=0&id=f881c2ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f881c2ce",
  null
  
)

export default component.exports